import React from 'react';
import PropTypes from 'prop-types';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  loading: {
    textAlign: 'center',
    paddingTop: '100px',
  },
}));

const LoadedComponent = ({
  children,
  loading,
  hasData,
  loadingContent,
  noDataContent,
}) => {
  const classes = useStyles();
  return (
    <>
      {loading && (
        <div className={classes.loading}>
          <CircularProgress />
          {loadingContent}
        </div>
      )}
      {!hasData && !loading && noDataContent}
      {hasData && !loading && <Fade in>{children}</Fade>}
    </>
  );
};

LoadedComponent.defaultProps = {
  children: null,
  hasData: true,
  loadingContent: <div>Loading Data...</div>,
  noDataContent: <div>No Data Found</div>,
};

LoadedComponent.propTypes = {
  children: PropTypes.any,
  loading: PropTypes.bool.isRequired,
  hasData: PropTypes.bool,
  loadingContent: PropTypes.any,
  noDataContent: PropTypes.any,
};

export default LoadedComponent;
